<!--NPS-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{ `${index + 1}、` }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>NPS</p>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          v-model="caseProblem"
          placeholder="您向朋友或同事推荐我们的可能性有多大"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div> -->

        <MyEditor
          v-model="caseProblem"
          placeholder="您向朋友或同事推荐我们的可能性有多大"
          @insertImg="handleCaseProblemImg"
          @input="handleInput"
        />
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
    </div>
    <div class="score-view">
      <div v-for="(item, index) in 10" class="score-view-item-active">
        {{ item }}
      </div>
    </div>
    <div class="must-container custom-check-box" style="margin-top: 10px">
      <el-checkbox v-model="isMust">必选题</el-checkbox>
    </div>
    <div class="option-settings" style="margin-top: 10px">
      <div class="question-header-right">
        <div class="add-batch">
          <span>分值设置：10分</span>
        </div>
      </div>
      <div></div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click.stop="saveClick">保存</div>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "EvaluationEditNPS",
  components: {
    // uploadImage: () => import("@/components/uploadImage/uploadImage.vue"),
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    isPage: {
      type: Number,
      default: 0,
    },
    ifRandomOrder: {
      type: String,
      default: "0",
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isMust: false,
      images: [],
      showUpload: false,
      caseProblem: "",
      isFocusIndex: "",
      totalScore: 10,
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (!newValue || Object.keys(newValue).length === 0) return;
        this.dataObj = newValue;
        this.caseProblem = newValue.caseProblem;
        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleInput() {
      this.handleUpdate();
    },
    handleUploadComplete(res) {
      this.images = res;
      this.handleUpdate();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.trim() === "" && this.caseProblem.includes(" ")) {
        this.$message.error("请输入题目");
        return;
      }
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem:
          this.caseProblem === ""
            ? "您向朋友或同事推荐我们的可能性有多大"
            : this.caseProblem,
        questionScore: 10,
      };
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdate();
    },
    handleUpdate() {
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem: this.caseProblem,
      };
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../QuestionEdit/question-edit-common.scss";

button {
  margin-left: 10px;
}

.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 2px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 5px;
  cursor: pointer;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.add-btn {
  width: 153px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #00c755;
    margin-left: 11px;
  }
}

.del1 {
  width: 19px;
  height: 19px;
}

.item {
  width: 100%;
  background: #f8f8f8;
  border: 1px dashed #3a60ff;
  border-radius: 4px;
  padding: 15px 12px;
  box-sizing: border-box;
  margin-top: 10px;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #2b2f36;
    margin-bottom: 10px;
  }
}

.question-header-right {
  display: flex;
  align-items: center;
}

.score-view {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
}

.score-view-item-active {
  width: 29px;
  height: 30px;
  line-height: 30px;
  background-color: #4a73f8;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.score-view-item-inactive {
  width: 27px;
  height: 28px;
  line-height: 27px;
  border: 1px solid #ededed;
  background-color: #f9f9f9;
  color: #2b2f36;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

.textarea-box {
  ::v-deep .el-textarea__inner {
    color: #4c4a56;
    border: none;
    padding: 0;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditNPS.vue